import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function Pagination({ page, totalPages, onPageChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-between pt-4">
      <p className="text-sm text-silver-500">
        Page {page} of {totalPages}
      </p>
      <div className="flex gap-2">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className="inline-flex items-center rounded-lg border border-silver-300 px-3 py-1.5 text-sm
            text-silver-700 hover:bg-silver-50 disabled:opacity-50 disabled:pointer-events-none"
        >
          <ChevronLeftIcon className="mr-1 h-4 w-4" /> Prev
        </button>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          className="inline-flex items-center rounded-lg border border-silver-300 px-3 py-1.5 text-sm
            text-silver-700 hover:bg-silver-50 disabled:opacity-50 disabled:pointer-events-none"
        >
          Next <ChevronRightIcon className="ml-1 h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
